import {createTheme, responsiveFontSizes} from "@mui/material";

export const theme = responsiveFontSizes(createTheme(
    {
        typography: {
            fontFamily: 'Arial B',
        },
        palette: {
            background:{
                default:'#fff'
            },
            primary: {
                main:'#d1112c',
                contrastText:'#fff'
            },
            secondary: {
                main: '#000'
            }
        }
    }
))
